<template>
  <div style="margin-top:30px;">
    <iframe style="width:100%;height:600px" :src="url" title="W3Schools Free Online Web Tutorials"></iframe>
    <div class="row">
      <div class="col-md-10"></div>
      <div class="col-md-2">
        <el-button type="primary" @click="$router.push('/impressao/devedores')">Voltar</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../../plugins/axios';
import impressaoService from '../../../services/impressaoService';
const ls = require('local-storage')
export default {
  data: () => ({
    url: '',
    html: '',
    mesesPagos: [],
    bolseiros: ls.get('bolseiros'),
    empresa: {
      'nome_empresa': 'Colégio Bendizer',
      'localidade': 'Vila-Alice',
      'zona': 'Rangel',
      'provincia': 'Luanda',
      'telefone': '999207671',
      'email': 'ColegioBendizer@gmail.co.ao',
      'detalhes': 'Matric. Conservatória do Registo Comercial de Luanda',
      'contribuente': '5480006576',
      'NIF': '2401268340'
    },
    turma: {
      descricao:  ls.get('turma').turma,
      classe: ls.get('turma').idAno_Academico,
      curso: ls.get('turma').curso,
      anolectivo: ls.get('turma').anoLectivo,
      semestre: ls.get('turma').semestre
    },
    emolumento: ls.get('emolumento'),
    pagos:0,
    npagos:0,
    totalBolseiros:0,
    devedores: [], // ls.get('estudantes_'),
    // devedores: [
    //   {
    //     'nome': 'Mário Carlos',
    //     'matricula': '665557',
    //     'mes': 'Janeiro,Fevereiro,Março,Abril',
    //     'divida': '20000'
    //   }
    // ],
    formatter: 0,
    date: null,
    meses:ls.get('meses'),
    precoPropina: ls.get('precoPropina'),
    config: null,
    baseUrl: '',
    templateFull: null,
    relatorioDados: ''
  }),
  async created () {
    await this.getTemplateRelatorio();
    this.config = ls.get('configuracaoinstituicao');
    this.getUrlImpressao();
   },

  methods: {

    async getUrlImpressao() {
      try {
        this.baseUrl = await impressaoService.getBaseUrl().then((res) => res.data[0].url);
      } catch (error) {
        console.log(error);
      } finally {
        this.html_pdf()
      }
    },

    async getTemplateRelatorio() {
      try {
        this.templateFull = await axios.get('/obterRelatorioByDescricao/ept').then((res) => res.data[0]);
      } catch (error) {
        console.log(error);
      }
    },

    ValidarClasse(id) {
      if(id == 1)  return '10ª'
      else if (id == 2) return '11ª'
      else if (id == 3) return '12ª'
      else if (id == 4) return '13ª'
      else return ''
    },

    html_pdf () {
      this.devedores = ls.get('estudantes');

      let template = this.templateFull.documento;
      this.rowsDivida()

      let dadoss = {
          '{{logoInstituicao}}': this.config.logo,
          '{{nomeInstituicao}}': this.config.nome,
          '{{sobreDocumento}}': `Lista de pagamentos da turma: `+this.turma.descricao,
          '{{emolumento}}': this.emolumento.descricao,
          '{{curso}}': this.turma.curso,
          '{{classe}}': this.ValidarClasse(this.turma.classe),
          '{{anoLectivo}}': this.turma.anolectivo,
          '{{author}}': ls.get('nomeUsuario'),
          '{{dataEmissao}}': this.correntDate(),
          '{{dados}}': this.relatorioDados,
          '{{totalEstudantes}}' : this.devedores.length,
          '{{totalPagos}}' : this.pagos,
          '{{totalNaoPagos}}' : this.npagos
        }

        const expressaoRegular = new RegExp(Object.keys(dadoss).join("|"), "g");
        template = template.replace(expressaoRegular, (match) => dadoss[match]);

          let options = {
            'format': 'A4',
            'border': {'right': '12mm', 'left': '12mm'},
            'header': {'height': '15mm'},
            'footer': {'height': '12mm'}
          }

          impressaoService.htmlToPdf(template, options);
    },

    /** Compondo o cabeçario contendo os meses  */
    mesesHeader (array) {
      let arrayMesesHeadeer = `  <tr>
        <th bgcolor="#DCDCDC" style="text-align:center;padding-top:10px;padding-bottom:10px;font-size: 8px;">Ord.</th>
        <th bgcolor="#DCDCDC"    style="text-align:center;padding-top:10px;padding-bottom:10px;font-size: 8px;width:50px!important">Nome</th>
        <th bgcolor="#DCDCDC"    style="text-align:center;font-size:8px;padding-top:10px;padding-bottom:10px;">Matrícula</th>`
      arrayMesesHeadeer += ` <th bgcolor="#DCDCDC" style="text-align:center;padding-top:10px;padding-bottom:10px;font-size: 8px">Situação</th></tr>`
      return arrayMesesHeadeer;
    },

    /** Compondo os items dos devedores */
    rowsDivida () {
      // let dados = ``
      this.npagos = 0
      let c = 1;
      this.pagos=0
      this.devedores.forEach(async element => { // Lista dos estudantes  //ls.get('mesespagos') -> lista dos meses pagos
      let results = ls.get('mesespagos').filter( f=>f.matricula === element.idMAtricula)
        /**
          * Verificação dos pagamentos dos meses selecionados para o estudante/matrícula filtrada
        */
        let mes1= (results.length)?'PAGO':'N/PAGO'
        //para as classes css
        let mes1css= (results.length)?'PAGO':'NPAGO'
        this.pagos += (mes1css === 'PAGO'  )?1:0
        this.npagos +=  (mes1css === 'NPAGO'   )?1:0

        let interacao1 = this.templateFull.documentoiteracao1;
        interacao1 = interacao1.replace('{{index}}', c++);
        interacao1 = interacao1.replace('{{nome}}', element.nome);
        interacao1 = interacao1.replace('{{matricula}}', element.idMAtricula);
        interacao1 = interacao1.replace('{{situacao}}', mes1);
        this.relatorioDados += interacao1;


        // dados += `<tr>
        //   <td valign="top" class="tptd" style="text-align:center;font-size:8px;">` + (this.devedores.indexOf(element)+1) + `</td>
        //   <td valign="top" class="tptd" style="text-align:justify;font-size:10px;">` + element.nome + `</td>
        //   <td valign="top" class="tptd" style="text-align:center;font-size:8px;" >` + element.idMAtricula + `</td>
        //   <td valign="top" class=`+mes1css+`>`+mes1+`</td>
        // </tr>`
      })
      // return dados;  
    },
    
    correntDate () {
      let data = new Date()
      var month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Maço'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return data.getDate().toString() + ' de ' + month[(data.getMonth())] + ' de ' + data.getFullYear().toString() + ' ás ' + data.getHours() + ':' + data.getMinutes() + ':' + data.getSeconds()
    }
  }
}
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.progressCircularIsMatriculaURL {
  margin: 1rem;

  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;

}
</style>
